

























































import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { EatsReward, EatsTransactionTypes } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class EatsRewardEditor extends Vue {
  @Prop()
  value!:EatsReward;

  workingReward:EatsReward | null = null;

  // Make visible to template
  EatsTransactionTypes:any = EatsTransactionTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  calculateCashBackLimit() : string {
    if (this.workingReward!.cashBackRate && this.workingReward!.purchaseLimit) {
      return `$${(this.workingReward!.purchaseLimit * this.workingReward!.cashBackRate / 100).toFixed(2)}`;
    }
    return '';
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as EatsReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
